var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryList } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import 'rxjs/add/operator/map';
import { PagerService } from '../pager.service';
var AllNewsComponent = /** @class */ (function () {
    function AllNewsComponent(apiService, util, router, sanitizer, pagerService) {
        this.apiService = apiService;
        this.util = util;
        this.router = router;
        this.sanitizer = sanitizer;
        this.pagerService = pagerService;
        this.isCrisis = false;
        // pager object
        this.pager = {};
    }
    AllNewsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, crisisConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.cookieData.isCrisis = true;
                            this.isCrisis = true;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        else {
                            this.cookieData.isCrisis = false;
                            this.isCrisis = false;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        return [4 /*yield*/, this.getAllNews()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AllNewsComponent.prototype.getAllNews = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para, newsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_iscrisis=" + this.isCrisis.toString();
                        return [4 /*yield*/, this.apiService.get("crmservice", "news", para)];
                    case 1:
                        newsList = _a.sent();
                        this.util.ShowWaiting(true);
                        if (newsList != null && newsList.length > 0) {
                            newsList.forEach(function (n) {
                                if (n.attachfilelist != null && n.attachfilelist.length > 0) {
                                    n.imgSrc = _this.sanitizer.bypassSecurityTrustUrl('data:' + n.attachfilelist[0].mimetype + ';base64, ' + n.attachfilelist[0].documentbody);
                                }
                            });
                            this.allItems = newsList;
                        }
                        else {
                            this.allItems = [];
                        }
                        this.setPage(1);
                        return [2 /*return*/];
                }
            });
        });
    };
    AllNewsComponent.prototype.setPage = function (page) {
        // get pager object from service
        this.pager = this.pagerService.getPager(this.allItems.length, page);
        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    AllNewsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.news.changes.subscribe(function (t) {
            _this.ngForRendred();
        });
    };
    AllNewsComponent.prototype.ngForRendred = function () {
        this.util.ShowWaiting(false);
    };
    return AllNewsComponent;
}());
export { AllNewsComponent };



// WEBPACK FOOTER //
// ./src/app/all-news/all-news.component.ts.pre-build-optimizer.js